export const EagerdogErrors = {
  SYSTEM: {
    UNEXPECTED: "ERROR.SYSTEM.UNEXPECTED",
  },

  GENERIC: {
    NOT_FOUND: "ERROR.GENERIC.NOT_FOUND",
    INVALID_REQUEST: "ERROR.GENERIC.INVALID_REQUEST",
  },

  AUTH: {
    UNAUTHORIZED: "ERROR.AUTH.UNAUTHORIZED",
    ACCESS_TOKEN_EXPIRED: "ERROR.AUTH.ACCESS_TOKEN_EXPIRED",
    REFRESH_TOKEN_EXPIRED: "ERROR.AUTH.REFRESH_TOKEN_EXPIRED",
    EMAIL_TOKEN_INVALID: "ERROR.AUTH.EMAIL_TOKEN_INVALID",
    NO_OBJECT_PERMISSIONS: "ERROR.AUTH.NO_OBJECT_PERMISSIONS",
    INVALID_USER_UPDATE: "ERROR.AUTH.INVALID_USER_UPDATE",
  },

  DATA: {
    RECORD_ALREADY_EXISTS: "ERROR.DATA.RECORD_ALREADY_EXISTS",
    MAX_RECORDS_REACHED: "ERROR.DATA.MAX_RECORDS_REACHED",
    INVALID_REQUEST: "ERROR.DATA.INVALID_REQUEST",
  },

  STORAGE: {
    FILE_UPLOAD_ERROR: "ERROR.STORAGE.FILE_UPLOAD_ERROR",
  },

  FORMS: {
    NO_CONTENT: "ERROR.FORMS.NO_CONTENT",
    NOT_READY_FOR_DOWNLOAD: "ERROR.FORMS.NOT_READY_FOR_DOWNLOAD",
  },

  // PAYMENT: {
  //   INVALID_PAYMENT_METHOD: "ERROR.PAYMENT.INVALID_PAYMENT_METHOD",
  // },
  REGISTRATION: {
    INVALID_REGISTRATION_KIND: "ERROR.REGISTRATION.INVALID_REGISTRATION_KIND",
    EXCLUDED_BREED: "ERROR.REGISTRATION.EXCLUDED_BREED",
    INVALID_WAITLIST_STATUS: "ERROR.REGISTRATION.INVALID_WAITLIST_STATUS",
    /** Approving would exceed the show's capacity; club managers may retry with allow_over_capacity. */
    SHOW_OVER_CAPACITY: "ERROR.REGISTRATION.SHOW_OVER_CAPACITY",
    ARMBAND_ALREADY_ASSIGNED: "ERROR.REGISTRATION.ARMBAND_ALREADY_ASSIGNED",
    ADD_ON_QUANTITY_EXCEEDED: "ERROR.REGISTRATION.ADD_ON_QUANTITY_EXCEEDED",
    INVALID_COURSE_SESSION: "ERROR.REGISTRATION.INVALID_COURSE_SESSION",
    CLUB_POINTS_EXCEEDED: "ERROR.REGISTRATION.CLUB_POINTS_EXCEEDED",
    VALIDATION_AGE: "ERROR.REGISTRATION.VALIDATION_AGE",
    REGISTRATION_CLOSED: "ERROR.REGISTRATION.REGISTRATION_CLOSED",
    USER_BANNED: "ERROR.REGISTRATION.USER_BANNED",
    NO_JUDGE_ASSIGNED: "ERROR.REGISTRATION.NO_JUDGE_ASSIGNED",
    PAYMENT_METHOD_REQUIRED: "ERROR.REGISTRATION.PAYMENT_METHOD_REQUIRED",
  },

  SCORES: {
    INVALID_SHOW_TYPE: "ERROR.SCORES.INVALID_SHOW_TYPE",
    SCORES_NOT_ENTERED: "ERROR.SCORES.SCORES_NOT_ENTERED",
    INVALID_CLASSES_COMBINATION: "ERROR.SCORES.INVALID_CLASSES_COMBINATION",
    SCORES_ALREADY_ENTERED: "ERROR.SCORES.SCORES_ALREADY_ENTERED",
  },

  RUN_TIMES: {
    RUN_TIME_NOT_AVAILABLE: "ERROR.RUN_TIMES.RUN_TIME_NOT_AVAILABLE",
    CANNOT_MASS_REPLACE: "ERROR.RUN_TIMES.CANNOT_MASS_REPLACE",
  },

  TRANSACTIONS: {
    INVALID_PAYMENT_METHOD: "ERROR.TRANSACTIONS.INVALID_PAYMENT_METHOD",
    MISSING_CHEQUE_NUMBER: "ERROR.TRANSACTIONS.MISSING_CHEQUE_NUMBER",
    INVALID_AMOUNT: "ERROR.TRANSACTIONS.INVALID_AMOUNT",
    DUPLICATE: "ERROR.TRANSACTIONS.DUPLICATE",
    INVALID_STATUS: "ERROR.TRANSACTIONS.INVALID_STATUS",
  },
};
